// extracted by mini-css-extract-plugin
export default {"body":"RegisterSuccess_body__irTeG"};